import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  ButtonResponsiveWrapper,
  Text,
  useResponsive,
  WarningIcon,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

import { useStore } from '../store/useApplyContributionRolloverModal.store';

const headerText = 'This rollover is tax-free and does not impact your contribution limit';
const description = `You can only transfer funds from Archer MSAs and other HSAs to an HSA once per year within 60 days of receipt.
 One rollover contribution to an HSA/MSA is allowed per year.`;

export const ApplyContributionRolloverModal = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const visible = useStore((store) => store.modalVisible);
  const onSetVisible = useStore((store) => store.handleChangeVisibility);
  const additionalAction = useStore((store) => store.additionalAction);
  return (
    <ModalWrapper testId="ApplyContributionRollover" visible={visible} onSetVisible={onSetVisible}>
      <Box align="center" pad={{ vertical: 'spacing24' }}>
        <WarningIcon size="48px" />
        <Text
          data-testid="ApplyContributionRolloverModal_header"
          margin={{ vertical: 'spacing12' }}
          textAlign="center"
          size="24px"
          weight={700}
        >
          {headerText}
        </Text>

        <Text
          data-testid="ApplyContributionRolloverModal_help-text"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {description}
        </Text>
        <ButtonResponsiveWrapper align="center" justify="center" fill gap="spacing8">
          <AppButton
            fill={isMobile}
            testId="ApplyContributionRolloverModal_modal_cancel"
            onClick={() => onSetVisible(false)}
            buttonType="secondary"
            width="200px"
          >
            {t('Cancel')}
          </AppButton>
          <AppButton
            fill={isMobile}
            testId="ApplyContributionRolloverModal_modal_confirm"
            onClick={() => additionalAction && additionalAction()}
            width="200px"
          >
            {t('Confirm')}
          </AppButton>
        </ButtonResponsiveWrapper>
      </Box>
    </ModalWrapper>
  );
};
